import { useParams } from 'react-router-dom'
import { useGetTrackInfoQuery } from '../../api/rtk-query/cruxApi'
import { skipToken } from '@reduxjs/toolkit/query'

const TrackerName = ({ id: trackId }) => {
  const { accountId: adAccountId } = useParams()
  const { name } = useGetTrackInfoQuery(
    trackId
      ? {
          trackId,
          adAccountId,
        }
      : skipToken,
    {
      selectFromResult: ({ data }) => ({
        name: data?.body?.name,
      }),
    }
  )
  return trackId ? `${name}(${trackId})` : '연동하지 않기'
}

export default TrackerName
